import { Toast, MessageBox } from "mint-ui";
export default {
    data() {
        return {
            current: {},
            sheetVisible: false,
            actions: [],
            list_refresh: false, //列表刷新
            isRefundShow: false,
            refundList: [],
            warehouseType: 1  ,// 1普通仓，2云仓
            showExpress:false,
            expresses:[],
            expressIndex:0,
            express_name:'',
            express_no:'',
            logistics_no:''
        }
    },
    methods: {
        refresh() {
            const { list_refresh } = this
            if (list_refresh) {
                this.updateList()
            } else{
                this.updateDetail()
            }
        },
        dispatch(ev, action) {
            ev.stopPropagation();
            if (arguments.length == 3) {
                this.current = this.list[arguments[2]];
                this.refundList = this.current.goods_list
                this.refundList.forEach((item, index) => {
                    item.isSelect = true;
                    item.maxNum = item.num;
                });
                this.list_refresh = true //列表需要刷新
            }
            action();
        },
        //再来一单
        oneMore() {
            const { current: { goods_list } } = this;
            let items = [];
            console.log(this.current);
            goods_list.forEach((item, index) => {
                var dic = {
                    item_id: item.item_id,
                    num: item.total_num
                };
                items.push(dic);
            });
            this.$.http
                .post("cart/create", {
                    items: JSON.stringify(items)
                })
                .then(res => {
                    Toast({ message: "添加成功" });
                });
        },
        // 取消订单
        cancel() {
            const { current: { order_id } } = this;
            console.log(order_id)
            MessageBox.confirm('你确定取消订单吗?').then(action => {
                if (action == 'confirm') {
                    this.$.http
                        .post("order/cancel", {
                            order_id
                        })
                        .then(res => {
                            Toast({ message: "订单取消成功" });
                            this.refresh()
                        })
                } else if (action == 'cancel') {

                }
            });

        },
        //选择支付方式确认
        pay() {
            Toast({ message: "移动端网页暂不支持下单支付，请在电脑端继续。" });
        },
        toPay(ev) {
            Toast({ message: "移动端网页暂不支持下单支付，请在电脑端继续。" });
        },
        //确认收货
        receipt() {
            const { current: { order_id, log_id }, warehouseType } = this;
            MessageBox.confirm('你确定确认收货吗?').then(action => {
                if (action == 'confirm') {
                    if (warehouseType == 1) {
                        // 1普通订单收货 2云仓订单收货
                        this.$.http
                            .post("order/receipt", {
                                order_id
                            })
                            .then(res => {
                                Toast({ message: "收货成功" });
                                this.refresh()
                            });
                    } else {
                        this.$.http
                            .post("warehouse/receipt", {
                                log_id
                            })
                            .then(res => {
                                Toast({ message: "收货成功" });
                                this.refresh()
                            });
                    }
                } else if (action == 'cancel') {

                }
            });
        },
        //上传凭证
        voucher() {
            Toast({ message: "移动端网页暂不支持下单支付，请在电脑端继续。" });
        },
        //查看物流
        logisti() {
            const { current: { delivery_info, to_address_info } } = this
            this.delivery_info = delivery_info
            this.to_address_info = to_address_info
            this.isLogShow = true
        },
        //去评论
        comment() {
            const { current: { order_id } } = this
            this.$router.push({ path: "mcomment", query: { order_id } })
        },
        //车辆跟踪
        track() {
            const { current: { order_id } } = this
            this.$router.push({ path: "mtrack", query: { order_id } })
        },
        //申请提货
        takeDelivery() {
            const { current: { order_id, order_no, pick_warehouse_info: { warehouse_id } }, warehouseType } = this
            const type = warehouseType // 1普通仓，2云仓
            this.$router.push({ path: "mtakeDelivery", query: { order_id, order_no, warehouse_id, type } })
        },
        //查看提货单
        viewDeliveryOrder() {
            this.$router.push({ path: "mdeliveryOrder" })
        },
        refund() {
            this.isRefundShow = true
        },
        // 添加快递信息
        express() {
          this.getExpresses()
          this.showExpress = true
        },
        getExpresses() {
          this.$.http.post('basic/expresses',{}).then(res=>{
            this.expresses = res.data
          })
        },


    }
}



// WEBPACK FOOTER //
// ./src/mixins/orderOptions.js